import { CUSTOMER_ACTION_TYPES, sortCustomerActionItems } from "./customerActionItems";

export const TODAY_TASK_FILTERS = Object.freeze([
  Object.freeze({ key: "download", type: CUSTOMER_ACTION_TYPES.ORIGINAL_DOWNLOAD, label: "원본 다운로드" }),
  Object.freeze({ key: "theme", type: CUSTOMER_ACTION_TYPES.THEME_SELECTION, label: "테마 선택" }),
  Object.freeze({ key: "photo", type: CUSTOMER_ACTION_TYPES.PRODUCT_PHOTO_SELECTION, label: "앨범 사진" }),
]);

export function getTodayTaskFilter(filterKey) {
  return TODAY_TASK_FILTERS.find((filter) => filter.key === filterKey) || null;
}

export function getTodayTaskCounts(items = []) {
  const safeItems = Array.isArray(items) ? items : [];
  const counts = TODAY_TASK_FILTERS.reduce((result, filter) => ({
    ...result,
    [filter.key]: safeItems.filter((item) => item?.type === filter.type).length,
  }), {});

  return { all: safeItems.length, ...counts };
}

export function filterTodayTaskItems(items = [], { filterKey, actionId } = {}) {
  const safeItems = Array.isArray(items) ? items : [];

  if (actionId) {
    const selectedItem = safeItems.find((item) => String(item?.id) === String(actionId));
    return selectedItem ? [selectedItem] : [];
  }

  const activeFilter = getTodayTaskFilter(filterKey);
  if (!activeFilter) return safeItems;
  return safeItems.filter((item) => item?.type === activeFilter.type);
}

export function getUrgentTodayTask(items = []) {
  return sortCustomerActionItems(items).find((item) => {
    const priority = item?.urgency || item?.priority;
    return item?.priorityRank === 0 || priority === "urgent" || priority === "critical";
  }) || null;
}
